import { PinButton } from "./PinButton";
import { ReplyButton } from "./ReplyButton";

export function MessageItem({ message, isOwnMessage, isAdmin, onPin, onReply }) {
  return (
    <div className={`flex items-start gap-2 mb-4 ${
      isOwnMessage ? 'flex-row-reverse' : ''
    }`}>
      {/* <img
        src={message.userPhoto || 'https://via.placeholder.com/40'}
        alt={message.userName}
        className="w-8 h-8 rounded-full"
      /> */}
      <div className={`relative p-2 rounded-lg ${
        isOwnMessage ? 'bg-blue-100' : 'bg-gray-100'
      }`}>
        {message.replyTo && (
          <div className="mb-2 text-sm bg-white/50 p-2 rounded">
            <div className="text-gray-500">
              Replying to <span className="font-medium">{message.replyTo.userName}</span>
            </div>
            <div className="text-gray-600 truncate">{message.replyTo.text}</div>
          </div>
        )}
        <p className="font-bold text-sm">{message.userName}: {message.text}</p>
        {isAdmin && (
          <>
            <PinButton onPin={onPin} />
            <ReplyButton onReply={() => onReply(message)} />
          </>
        )}
      </div>
    </div>
  );
}